import React, { useState } from 'react'
import { Center, HStack, Switch } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import { useCPDFeatureFlag } from 'front-end/src/app/hooks/useFeatureFlags'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'
import {
  useActivityCpdGroupPermissionQuery,
  useMarkItemsAsCpdMutation
} from 'front-end/src/pages/activity-history/ActivityHistory.codegen'

interface TopicCPDMarkToggleProps {
  initialCpdStatus: boolean
  topicEnrolmentId: number
  dataTest?: string
}

const TopicCPDMarkToggle = ({
  initialCpdStatus,
  topicEnrolmentId,
  dataTest = 'CPDMark'
}: TopicCPDMarkToggleProps) => {
  const { cpdAlias, isCPDEnabledInAccountSettings } = useCPDFeatureFlag()
  const { theme } = useLooopTheme()
  const [isCpd, setCpd] = useState(initialCpdStatus)
  const [markAsCpdMutation, { loading }] = useMarkItemsAsCpdMutation({
    onCompleted: () => setCpd(!isCpd)
  })
  const { data, loading: isGroupPermissionPending } =
    useActivityCpdGroupPermissionQuery()
  const isMemberOfCpdGroup = !!data?.me?.isMemberOfCPDGroup

  const handleChange = async () => {
    if (loading) return

    await markAsCpdMutation({
      variables: {
        cpdInput: [
          {
            itemId: topicEnrolmentId,
            isCpd: !isCpd,
            itemType: 'userTopic'
          }
        ]
      }
    })
  }

  if (
    isGroupPermissionPending ||
    !isCPDEnabledInAccountSettings ||
    !isMemberOfCpdGroup
  )
    return null

  return (
    <Center
      m="0 20px"
      padding="20px"
      bgColor="white"
      borderRadius={theme.radii.base}
      data-test={dataTest}
    >
      <HStack spacing="24px" shouldWrapChildren>
        <Trans>Was this resource applicable for your {cpdAlias} hours?</Trans>
        <Switch
          isDisabled={loading}
          isChecked={isCpd}
          onChange={handleChange}
          dataTest="CPDToggle"
        />
      </HStack>
    </Center>
  )
}

export default TopicCPDMarkToggle
